module.exports = __webpack_public_path__ + "static/media/city.967a2ef6.svg";